// Generated by prepyo-voicegen (voicegen.py learn --course japanese). Do not edit by hand.
// Each spoken text of the Learn Japanese course, mapped to its stored audio in
// question_assets, served at /api/v1/questions/assets/<id>. Until it is
// generated, the course speaks with the browser's Japanese voice.
export const LEARN_AUDIO_JA: Record<string, string> = {};
